import { init, instrumentAngularRouting } from '@sentry/angular';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  init({
    dsn: environment.sentryDSN,
    integrations: [
      new TracingIntegrations.BrowserTracing({
        tracingOrigins: environment.tracingOrigins,
        routingInstrumentation: instrumentAngularRouting,
      }),
    ],
    tracesSampleRate: 1,
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
